import axios from "axios";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import Loading from "../../components/loading/Loading";

const AddUpdate = () => {
  const [updateText, setUpdateText] = useState("");
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [editingId, setEditingId] = useState(null); // for update

  // ================= GET ALL UPDATES =================
  const fetchUpdates = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/get-updates");

      // Use response.data.data if your backend returns {success, data, count}
      const updateArray = response.data.data || response.data;

      const mapped = updateArray.map((item) => ({
        id: item._id,
        update: item.update,
        createdAt: item.createdAt
          ? new Date(item.createdAt).toLocaleString()
          : "",
      }));

      setUpdates(mapped);
    } catch (error) {
      console.error("Error fetching updates:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUpdates();
  }, []);

  // ================= ADD / UPDATE =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingId) {
        // UPDATE
        await axios.put(`/update/${editingId}`, { update: updateText });
        setSuccess("Update modified successfully!");
      } else {
        // ADD
        await axios.post("/add-update", { update: updateText });
        setSuccess("Update added successfully!");
      }

      setUpdateText("");
      setEditingId(null);
      fetchUpdates();
    } catch (err) {
      console.error(err);
      setError("Operation failed");
    }
  };

  // Clear success message automatically
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(""), 2000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  // ================= DELETE =================
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this update?")) return;

    try {
      await axios.delete(`/delete/${id}`);
      fetchUpdates();
    } catch (err) {
      console.error(err);
      setError("Delete failed");
    }
  };

  // ================= DATA GRID COLUMNS =================
  const columns = [
    { field: "update", headerName: "Update", width: 400 },
    { field: "createdAt", headerName: "Created At", width: 200 },
    {
      field: "actions",
      headerName: "Actions",
      width: 220,
      renderCell: (params) => (
        <>
          <button
            style={{
              background: "orange",
              color: "white",
              borderRadius: "5px",
              border: "none",
              padding: "5px 10px",
              marginRight: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              setUpdateText(params.row.update);
              setEditingId(params.row.id);
            }}
          >
            Edit
          </button>

          <button
            style={{
              background: "red",
              color: "white",
              borderRadius: "5px",
              border: "none",
              padding: "5px 10px",
              cursor: "pointer",
            }}
            onClick={() => handleDelete(params.row.id)}
          >
            Delete
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="main_wrp">
      <div className="main_page_wrp">
        <div className="head_wrp">
          <h3>
            All <em>Updates</em>
          </h3>
        </div>

        <div className="main_body_wrp">
          {/* ================= FORM ================= */}
          <form onSubmit={handleSubmit}>
            <div className="add_main">
              <div className="add_t_form">
                <div className="in_main">
                  <label>Update</label>
                  <input
                    value={updateText}
                    onChange={(e) => setUpdateText(e.target.value)}
                    required
                  />
                </div>

                <button type="submit" className="btn_submit_form">
                  {editingId ? "Update" : "Add"}
                </button>
              </div>

              {error && <small style={{ color: "red" }}>{error}</small>}
              {success && <small style={{ color: "green" }}>{success}</small>}
            </div>
          </form>

          {/* ================= TABLE ================= */}
          <div className="main_body_wrp" style={{ marginTop: "20px" }}>
            {loading ? (
              <Loading />
            ) : (
              <DataGrid
                rows={updates}
                columns={columns}
                pageSizeOptions={[5, 10]}
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: 5, page: 0 },
                  },
                }}
                disableRowSelectionOnClick
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUpdate;
